/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TimeSeries } from 'pondjs';

import { roundAndExponent } from '../../utils/math';

interface TrackerValueType {
  value: number;
  label: string;
}

const fontSize = '12px';
const margin = 25;
const width = 500;
const border = 2;
const padding = 3;
const useStyles = makeStyles({
  tooltipContainer: {
    width: `${width}px`,
    marginLeft: `${margin}px`,
    marginRight: `${margin}px`,
    padding: `${padding}px`,
    position: 'absolute',
    pointerEvents: 'none',
    background: 'white',
    border: `solid ${border}px #999`,
    fontSize,
  },
  time: {
    fontSize,
  },
  labelText: {
    wordBreak: 'break-all',
  },
});

const insertTrackerValues = (
  name: string,
  chartData: TimeSeries,
  tracker: Date,
  trackerValues: TrackerValueType[]
): void => {
  const index = chartData.bisect(new Date(tracker), 0);
  const columns = chartData.columns();
  columns
    .filter((column) => column === 'value')
    .map((column) => {
      return {
        label: `${name} ${column}`,
        value: chartData.at(index).get(column),
      };
    })
    .filter((data) => data.value !== null)
    .forEach((data) => trackerValues.push(data));
};

interface TimeseriesChartTooltipProps {
  primaryName: string;
  secondaryName?: string;
  xPosition: number;
  primaryChartData: TimeSeries;
  secondaryChartData?: TimeSeries;
  tracker: Date;
}

const TimeseriesChartTooltip: React.FC<TimeseriesChartTooltipProps> = ({
  primaryName,
  secondaryName = '',
  xPosition,
  primaryChartData,
  secondaryChartData,
  tracker,
}: TimeseriesChartTooltipProps) => {
  const trackerValues: TrackerValueType[] = [];
  if (tracker) {
    insertTrackerValues(primaryName, primaryChartData, tracker, trackerValues);
    if (typeof secondaryChartData !== 'undefined') {
      insertTrackerValues(secondaryName, secondaryChartData, tracker, trackerValues);
    }
  }

  const classes = useStyles();

  if (tracker && trackerValues.length !== 0) {
    return (
      <div
        className={classes.tooltipContainer}
        style={{ left: xPosition < 550 ? xPosition : xPosition - width - 2 * (margin + border + padding) }}
      >
        <Typography className={classes.time} color="textSecondary" variant="body2">
          <b>{moment(tracker).format('DD-MMM-YYYY hh:mm:ss a')}</b>
        </Typography>
        {trackerValues.map(({ label, value }) => (
          <p className={classes.labelText} key={label}>
            {`${label}: `} <b>{`${roundAndExponent(value)}`}</b>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default TimeseriesChartTooltip;
